<template lang="pug">
div
  SubHeader(apiname='work',headname='対応ワーク')
  .card
    .container-fluid
      h3.box-title 対応ワーク一覧
      WorkList(apiname='work',editPath='edit')
      router-link(to='edit')
        el-button.col-md-12(type='primary', icon='el-icon-edit') 新規登録
</template>

<script>
import SubHeader from '@/views/components/swan/common/SubHeader'
import WorkList from './List'

export default {
  name: 'Top',
  data () {
    return {
    }
  },
  components: {
    SubHeader,
    WorkList
  }
}
</script>

<style scoped>
.card {
  padding: 16px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/components/swan/work/top.vue